import customHeaders, { getSpace } from '../../common/headers';
import { TableBox } from '@lk-gtcom/ecomlab-components';
import { useParams } from 'react-router-dom';
import { usePagination, Checkbox, ButtonBasic } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import { FileItemComponent } from '../../components/FileItemComponent/FileItemComponent';
import './FilesPage.scss';
import { DropZoneDirectory } from '../../components/DropZoneDirectory/DropZoneDirectory';
import { useState, useEffect } from 'react';
import { MoonLoader } from 'react-spinners';
import { useRef } from 'react';
import { useDataTable } from '../../common/hooks';
import { ModalEditFile } from './ModalEditFile/ModalEditFile';
import { useResponseHandler } from '../../common/auth';
import { ModalTransferFile } from './ModalTransferFile/ModalTransferFile';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import RoleBadje from '../../components/RoleBadge/RoleBadje';
import { TextPage } from '../../components/TextPage/TextPage';
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning';

const FilesPage = ({
    selectView,
    search,
    sortingRef,
    projectId = null,
    checkList,
    setCheckList,
    isUpdateDirectory
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
    const path = useParams()['*'];
    const current_directory = path?.split('/').at(-2)

    const [role, setRole] = useState(null)
    const can_manage = (role == 'collaborator' || role == 'owner')
    const [saveFile, setSaveFile] = useState()
    const [filesData, setFilesData] = useState()
    const [save, setSave] = useState(null)

    const [listFiles, setListFiles] = useState([])
    const [load, setLoad] = useState(false)
    const [loadList, setLoadList] = useState([])

    const paginatorRef = useRef();
    const paginatorCallback = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
    const { setLoading, setFetchedData, setHeaders, setSort, setFilters } = setTableFuncs;
    const [currentFile, setCurrentFile] = useState(null)
    const [isModalEditFile, setIsModalEditFile] = useState('')

    const [isModalTransfer, setIsModalTransfer] = useState(false)
    const [isModalDelete, setIsModalDelete] = useState(false)

    // Состояния для выделения областью
    const [isSelecting, setIsSelecting] = useState(false);
    const [selectionRect, setSelectionRect] = useState(null);
    const [highlightedIds, setHighlightedIds] = useState(new Set());
    const contentRef = useRef(null);

    // Состояния для drag and drop
    const [isDragging, setIsDragging] = useState(false);
    const [dragOverItemId, setDragOverItemId] = useState(null);
    const [dragOverPosition, setDragOverPosition] = useState(null);

    const dragStartRef = useRef({ x: 0, y: 0 });
    const dragEndRef = useRef({ x: 0, y: 0 });

    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef.current?.params
    );

    const contextMenuArr = [
        {
            label: 'Копировать ссылку',
            onClick: (e) => {
                navigator.clipboard.writeText(e?.['Название']?.[1])
                alert(`Ссылка скопирована ${e?.['Название']?.[1]}`)
            },
        },
        ...can_manage ? [
            {
                label: 'Переименовать файл',
                onClick: (e) => {
                    setCurrentFile(e)
                    setIsModalEditFile(true)
                },
            },
            {
                label: 'Удалить',
                onClick: (e) => {
                    fetchDeleteFileFromDirectory(e?.id);
                    setTimeout(() => currentFetchGetList(), 500)
                },
            },
        ]
            : []
    ];

    // Получить права на директорию
    const fetchGetPermission = (id) => {
        if (!current_directory) return
        let url = `https://apps2.ecomru.ru:4460/api/v1/directory/${current_directory}/permission`

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => setRole(json?.role))
            .catch((err) => console.error(err));
    };


    // Все чекбоксы
    const fetchGetAllFiles = (id) => {
        if (!current_directory) return
        let url = `https://apps2.ecomru.ru:4460/api/v1/file/${current_directory}`

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => setCheckList(json?.files || []))
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        fetchGetPermission()
    }, [current_directory]);

    // Получить таблицу файлов по id директории 
    const fetchGetFileList = (params, abortController = new AbortController()) => {
        setLoad(true)

        let sort;
        let filtersParam;
        let sorting = null;

        if (params) {
            [sort, filtersParam] = params;
        }

        const isSpace = current_directory ? '' : '/space'

        let url = `https://apps0.ecomru.ru:4420/api/v1/directory${isSpace}/files${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
            : ''}`

        const directory_id = current_directory ? { directory_id: parseInt(current_directory) } : {}

        const body = JSON.stringify({
            search_param: search,
            page: page,
            limit: limit ?? 10,
            ...directory_id,
            filters: filtersParam,
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                setTable(json);
                const { data, sort } = json
                const current_list = data.map((el, ind) => {
                    return {
                        id: el?.[0],
                        created_at: el?.[1]?.[0],
                        file_size_kb: Number((el?.[5]?.[0]).replace(/\s/g, '')) * 1024,
                        new_filename: el?.[3]?.[0],
                        url: el?.[3]?.[1]
                    }
                })
                setListFiles(current_list)
                setTotal(json.total)
                if (sort) {
                    setSort(sort);
                }
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setLoad(false)
                if (abortController.signal.aborted) return
            });
    };

    // Получить таблицу файлов по id проекта в задачах
    const fetchGetFileListByTask = (params, abortController = new AbortController()) => {
        setLoad(true)

        let sort;
        let filtersParam;
        let sorting = null;

        if (params) {
            [sort, filtersParam] = params;
        }

        const isSpace = current_directory ? '' : '/space'

        const orderParam = sortingRef.current
            ? sortingRef.current.param
            : 'Дата создания';

        const orderParamDirection = sortingRef.current
            ? sortingRef.current.direction
            : 'DESC';

        const bordId = ''
        // const bordId = `&board_id=1`

        if (current_directory) {
            fetchGetFileList()
        } else {
            let url = `https://portals.ecomru.ru/api/v3/files/?project_id=${projectId}${bordId}&page=${page}&limit=${limit || 10}`

            fetch(url, { method: 'GET', headers, signal: abortController.signal })
                .then(handleTableResponse)
                .then((json) => {
                    setTable(json);
                    const { data, sort } = json
                    const current_list = data.map((el, ind) => {
                        return {
                            id: el?.[0],
                            created_at: el?.[1]?.[0],
                            file_size_kb: Number((el?.[5]?.[0]).replace(/\s/g, '')) * 1024,
                            new_filename: el?.[3]?.[0],
                            url: el?.[3]?.[1]
                        }
                    })
                    setListFiles(current_list)
                    setTotal(json.total)
                    if (sort) {
                        setSort(sort);
                    }
                })
                .catch((err) => console.error(err))
                .finally(() => {
                    setLoad(false)
                    if (abortController.signal.aborted) return
                });
        }
    };

    const currentFetchGetList = projectId ? fetchGetFileListByTask : fetchGetFileList

    // Удаление файла из директории
    const fetchDeleteFileFromDirectory = (file_id) => {
        let url = `https://apps2.ecomru.ru:4460/api/v1/file/remove-from-directory`

        const body = JSON.stringify({
            directory_id: current_directory,
            file_id
        })

        fetch(url, { method: 'DELETE', headers, body })
            .then(handleTableResponse)
            .then((json) => setTimeout(() => currentFetchGetList(), 100))
            .catch((err) => console.error(err))
            .finally(() => {
                setLoad(false)
            });
    };

    // Массовое удаление файлов 
    const fetchDeleteMassFileFromDirectory = (file_id) => {
        let url = `https://apps2.ecomru.ru:4460/api/v1/file/bulk-remove-from-directory`

        const body = JSON.stringify({
            directory_id: current_directory,
            file_ids: checkList
        })

        fetch(url, { method: 'DELETE', headers, body })
            .then(handleTableResponse)
            .then((json) => {
                setTimeout(() => currentFetchGetList(), 100)
                setCheckList([])
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setLoad(false)
            });
    };

    // Функция для перемещения выбранных файлов
    const moveSelectedFiles = async (targetId, position) => {
        if (!can_manage) return;
        if (checkList.length === 0) return;
        if (checkList.includes(targetId)) return;

        // Получаем индексы перемещаемых файлов
        const sourceIndices = checkList.map(id => listFiles.findIndex(f => f.id === id)).filter(i => i !== -1);
        const targetIndex = listFiles.findIndex(f => f.id === targetId);

        if (sourceIndices.length === 0 || targetIndex === -1) return;

        // Сортируем индексы по убыванию для правильного удаления
        const sortedSourceIndices = [...sourceIndices].sort((a, b) => b - a);

        // Создаем новый массив без перемещаемых файлов
        const newList = [...listFiles];
        const movedFiles = [];

        // Удаляем файлы
        sortedSourceIndices.forEach(index => {
            movedFiles.unshift(newList[index]);
            newList.splice(index, 1);
        });

        // Вычисляем новый индекс для вставки
        let newTargetIndex = targetIndex;
        let removedCount = 0;
        for (let i = 0; i < targetIndex; i++) {
            if (sourceIndices.includes(i)) {
                removedCount++;
            }
        }
        newTargetIndex = targetIndex - removedCount;

        if (position === 'bottom') {
            newTargetIndex = newTargetIndex + 1;
        }

        // Вставляем файлы
        newList.splice(newTargetIndex, 0, ...movedFiles);

        // Обновляем UI
        setListFiles(newList);

        // Отправляем запрос на сервер
        try {
            const url = `https://apps2.ecomru.ru:4460/api/v1/files/bulk-reorder`;
            const body = JSON.stringify({
                directory_id: current_directory,
                file_ids: checkList,
                target_file_id: targetId,
                position: position
            });

            const response = await fetch(url, { method: 'POST', headers, body });

            if (!response.ok) {
                throw new Error('Failed to reorder files');
            }

            // Очищаем выбор
            setCheckList([]);

        } catch (error) {
            console.error('Error moving files:', error);
            currentFetchGetList();
        }
    };

    useEffect(() => {
        resetPaginator()
        setListFiles([])
        setLoadList([])
        setCheckList([])
        setHighlightedIds(new Set())
    }, [current_directory]);

    useEffect(() => {
        if (search) {
            resetPaginator()
        }
        if (!isModalEditFile) {
            currentFetchGetList([])
        }
    }, [
        page,
        limit,
        current_directory,
        isModalEditFile,
        sortingRef,
        search,
        isUpdateDirectory
    ]);

    useEffect(() => {
        if (loadList?.length) {
            const content = loadList?.map(({ name, status }) => {
                return <div className='files-page__snackbar-row'>
                    <span>{name}</span>
                    {status == 'true' && <span>✓</span>}
                    {status == 'error' && <span style={{ color: 'red' }}>error</span>}
                    {status == 'false' &&
                        <MoonLoader
                            color="#fff"
                            size={16}
                            speedMultiplier={0.5}
                        />
                    }
                </div>
            })
        }
    }, [loadList]);



    // Функции для выделения областью
    const getElementIndex = (element) => {
        if (!element || !contentRef.current) return -1;
        const items = contentRef.current.querySelectorAll('.files-page__item');
        for (let i = 0; i < items.length; i++) {
            if (items[i] === element || items[i].contains(element)) {
                return i;
            }
        }
        return -1;
    };

    const isRectIntersect = (rect1, rect2) => {
        return !(rect2.left > rect1.right ||
            rect2.right < rect1.left ||
            rect2.top > rect1.bottom ||
            rect2.bottom < rect1.top);
    };

    const getIdsInRect = (startX, startY, endX, endY) => {
        if (!contentRef.current) return [];

        const left = Math.min(startX, endX);
        const top = Math.min(startY, endY);
        const right = Math.max(startX, endX);
        const bottom = Math.max(startY, endY);
        const rect = { left, top, right, bottom };

        const fileItems = contentRef.current.querySelectorAll('.files-page__item');
        const ids = [];

        fileItems.forEach(item => {
            const itemRect = item.getBoundingClientRect();
            const itemRectObj = {
                left: itemRect.left,
                top: itemRect.top,
                right: itemRect.right,
                bottom: itemRect.bottom
            };

            if (isRectIntersect(rect, itemRectObj)) {
                const index = getElementIndex(item);
                if (index !== -1) {
                    ids.push(listFiles[index].id);
                }
            }
        });

        return ids;
    };

    const updateHighlight = (startX, startY, endX, endY) => {
        const idsInRect = getIdsInRect(startX, startY, endX, endY);
        setHighlightedIds(new Set(idsInRect));
    };

    // Drag and Drop обработчики
    const handleDragStart = (e, fileId) => {
        if (!can_manage) {
            e.preventDefault();
            return false;
        }

        // Если файл не выбран, очищаем выбор и выбираем текущий
        if (!checkList.includes(fileId)) {
            setCheckList([fileId]);
        }

        // Устанавливаем данные для перетаскивания
        const dragData = {
            fileIds: checkList.includes(fileId) ? checkList : [fileId],
            sourceId: fileId
        };

        e.dataTransfer.setData('text/plain', JSON.stringify(dragData));
        e.dataTransfer.effectAllowed = 'move';

        // Создаем кастомное изображение для drag
        const dragImage = document.createElement('div');
        const count = dragData.fileIds.length;
        dragImage.textContent = count === 1 ? '1 файл' : `${count} файлов`;
        dragImage.style.backgroundColor = '#4c9aff';
        dragImage.style.color = 'white';
        dragImage.style.padding = '8px 12px';
        dragImage.style.borderRadius = '4px';
        dragImage.style.fontSize = '12px';
        dragImage.style.position = 'absolute';
        dragImage.style.top = '-1000px';
        document.body.appendChild(dragImage);
        e.dataTransfer.setDragImage(dragImage, 0, 0);

        setTimeout(() => document.body.removeChild(dragImage), 0);

        setIsDragging(true);
        return true;
    };

    const handleDragOver = (e, fileId) => {
        if (!can_manage || checkList.length === 0) return;

        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';

        // Определяем позицию вставки
        const rect = e.currentTarget.getBoundingClientRect();
        const mouseY = e.clientY;
        const threshold = rect.top + rect.height / 2;
        const position = mouseY < threshold ? 'top' : 'bottom';

        setDragOverItemId(fileId);
        setDragOverPosition(position);
    };

    const handleDragLeave = () => {
        setDragOverItemId(null);
        setDragOverPosition(null);
    };

    const handleDrop = async (e, targetFileId) => {
        e.preventDefault();
        console.log(e)

        if (!can_manage || checkList.length === 0) {
            resetDragState();
            return;
        }

        // Проверяем, не пытаемся ли перетащить на себя
        if (checkList.includes(targetFileId)) {
            resetDragState();
            return;
        }

        await moveSelectedFiles(targetFileId, dragOverPosition);
        resetDragState();
    };

    const handleDragEnd = () => {
        resetDragState();
    };

    const resetDragState = () => {
        setIsDragging(false);
        setDragOverItemId(null);
        setDragOverPosition(null);
    };

    const handleMouseMove = (e) => {
        if (!isSelecting) return;

        const left = Math.min(dragStartRef.current.x, e.clientX);
        const top = Math.min(dragStartRef.current.y, e.clientY);
        const width = Math.abs(e.clientX - dragStartRef.current.x);
        const height = Math.abs(e.clientY - dragStartRef.current.y);

        setSelectionRect({ left, top, width, height });
        dragEndRef.current = { x: e.clientX, y: e.clientY };
        updateHighlight(dragStartRef.current.x, dragStartRef.current.y, e.clientX, e.clientY);
    };

    const handleMouseDown = (e) => {
        // Игнорируем интерактивные элементы и пагинатор
        if (e.target.closest('.checkbox') ||
            e.target.closest('button') ||
            e.target.closest('a') ||
            e.target.closest('.file-item-component__actions') ||
            e.target.closest('.files-page__settings-panel') ||
            e.target.closest('.paginator')) {
            return;
        }

        const fileItem = e.target.closest('.files-page__item');
        const currentIndex = fileItem ? getElementIndex(fileItem) : -1;

        // Выделение областью на пустом месте
        if (currentIndex === -1) {
            dragStartRef.current = { x: e.clientX, y: e.clientY };
            dragEndRef.current = { x: e.clientX, y: e.clientY };
            setIsSelecting(true);
            setSelectionRect({ left: e.clientX, top: e.clientY, width: 0, height: 0 });
            setHighlightedIds(new Set());
            e.preventDefault();
        }
    };

    const handleMouseUp = () => {
        if (!isSelecting) return;

        const idsInRect = getIdsInRect(
            dragStartRef.current.x,
            dragStartRef.current.y,
            dragEndRef.current.x,
            dragEndRef.current.y
        );

        if (idsInRect.length > 0) {
            setCheckList(prev => {
                const newSelection = [...prev];
                idsInRect.forEach(id => {
                    if (!newSelection.includes(id)) {
                        newSelection.push(id);
                    }
                });
                return newSelection;
            });
        }

        setIsSelecting(false);
        setSelectionRect(null);
        setHighlightedIds(new Set());
    };

    // Глобальные обработчики
    useEffect(() => {
        if (selectView !== 'Table' && current_directory && listFiles.length > 0) {
            const handleDocumentMouseMove = (e) => handleMouseMove(e);
            const handleDocumentMouseUp = () => handleMouseUp();

            const contentElement = contentRef.current;
            if (contentElement) {
                contentElement.addEventListener('mousedown', handleMouseDown);
                document.addEventListener('mousemove', handleDocumentMouseMove);
                document.addEventListener('mouseup', handleDocumentMouseUp);

                return () => {
                    contentElement.removeEventListener('mousedown', handleMouseDown);
                    document.removeEventListener('mousemove', handleDocumentMouseMove);
                    document.removeEventListener('mouseup', handleDocumentMouseUp);
                };
            }
        }
    }, [selectView, current_directory, listFiles, isSelecting]);

    // Сброс выделения при клике вне контейнера
    const handleClickOutside = (e) => {
        if (contentRef.current && !contentRef.current.contains(e.target)) {
            setIsSelecting(false);
            setSelectionRect(null);
            setHighlightedIds(new Set());
        }
    };

    useEffect(() => {
        if (selectView !== 'Table' && current_directory) {
            document.addEventListener('click', handleClickOutside);
            return () => {
                document.removeEventListener('click', handleClickOutside);
            };
        }
    }, [selectView, current_directory]);

    const isHighlighted = (id) => {
        return isSelecting && highlightedIds.has(id);
    };

    const isDragOverTarget = (id) => {
        return dragOverItemId === id;
    };

    return (
        <>
            {isModalEditFile && <ModalEditFile
                setIsModal={setIsModalEditFile}
                currentFile={currentFile}
                setCurrentFile={setCurrentFile}
            />}

            {isModalDelete && <ModalWarning
                headerText='Подтвердите удаление'
                messageText={'Удалить выбранные файлы?'}
                approveButtonText='Удалить'
                cancelButtonText='Отмена'
                colorBtn='red'
                onApproveClick={() => {
                    fetchDeleteMassFileFromDirectory()
                    setIsModalDelete(false)
                }}
                onCancelClick={() => setIsModalDelete(false)}
            />}

            {isModalTransfer && <ModalTransferFile
                setIsModal={setIsModalTransfer}
            />}

            <div className="files-page">
                <div className="files-page__top-panel">
                    {(current_directory && can_manage) &&
                        <DropZoneDirectory
                            id={current_directory}
                            update={currentFetchGetList}
                            setSave={setSave}
                            setLoadList={setLoadList}
                        />}

                    <TitlePage
                        medium
                        title='Список файлов:'
                    />

                    <div className="files-page__settings-panel">
                        <RoleBadje
                            role={role}
                        />

                        <TextPage
                            text={<>Всего файлов - <span style={{ color: '#1890FF', fontWeight: 700 }}>{total}</span></>}
                            style={{ fontSize: '13px' }}
                        />

                        {(can_manage && selectView != 'Table') &&
                            <div className="files-page__settings-panel-right">
                                <Checkbox
                                    disabled={total === 0}
                                    value={total == checkList?.length && total !== 0}
                                    onChange={(e) => {
                                        if (total == checkList?.length && total !== 0) {
                                            setCheckList([])
                                        } else {
                                            fetchGetAllFiles()
                                        }
                                    }}
                                >
                                    Выбрать все
                                </Checkbox>

                                <ButtonBasic
                                    whiteBlue
                                    text="Отменить выбор"
                                    width='140px'
                                    size='32px'
                                    onClick={() => setCheckList([])}
                                    disabled={!checkList?.length}
                                />

                                <ButtonBasic
                                    red
                                    text="Удалить файлы"
                                    width='140px'
                                    size='32px'
                                    onClick={() => setIsModalDelete(true)}
                                    disabled={!checkList?.length}
                                />
                            </div>}
                    </div>

                    {(current_directory && can_manage && (selectView != 'Table')) && <TextPage
                        text='Выделяйте область с файлами и перетаскивайте их в другие папки'
                        style={{
                            fontSize: '11px',
                            color: ' rgb(148, 163, 184)'
                        }}
                    />}
                </div>

                <div
                    className="files-page__content"
                    ref={contentRef}
                    style={{
                        userSelect: 'none',
                        position: 'relative',
                        cursor: isSelecting ? 'crosshair' : 'default'
                    }}
                >

                    {(selectView != 'Table'
                        ?
                        <>
                            {load ? (
                                <div className='files-page__loader'>
                                    <MoonLoader color="#7b7b7b" speedMultiplier={0.5} />
                                </div>
                            ) : listFiles?.length > 0 ?
                                listFiles?.map((el) => {
                                    const selected = checkList.includes(el.id);
                                    const highlighted = isHighlighted(el.id);
                                    const isDragOver = isDragOverTarget(el.id);
                                    const dragPosition = dragOverPosition;

                                    return (
                                        <label
                                            className={`files-page__item 
                                                    ${selected || highlighted ? 'files-page__item_highlighted' : ''}
                                                    ${isDragOver ? `files-page__item_drag-over-${dragPosition}` : ''}`}
                                            key={el?.id}
                                            draggable={can_manage && selected}
                                            onDragStart={(e) => handleDragStart(e, el.id)}
                                            onDragOver={(e) => handleDragOver(e, el.id)}
                                            onDragLeave={handleDragLeave}
                                            onDrop={(e) => handleDrop(e, el.id)}
                                            onDragEnd={handleDragEnd}
                                        >
                                            {(current_directory && can_manage) && (
                                                <Checkbox
                                                    value={selected}
                                                    onChange={() => {
                                                        if (!checkList.includes(el.id)) {
                                                            setCheckList(prev => [...prev, el.id]);
                                                        } else {
                                                            setCheckList(prev => prev.filter(id => id !== el.id));
                                                        }
                                                    }}
                                                />
                                            )}

                                            <FileItemComponent
                                                comment_id={el.id}
                                                fetchDeleteFiles={() => fetchDeleteFileFromDirectory(el.id)}
                                                fetchGetFiles={currentFetchGetList}
                                                isEdit={true}
                                                created_at={el?.created_at}
                                                file_size_kb={el.file_size_kb}
                                                new_filename={el.new_filename}
                                                url={el.url}
                                                authorEmail={localStorage.getItem('email')}
                                                filesdata={saveFile}
                                                setFilesData={setFilesData}
                                                positionDrop={'top'}
                                                saveFile={saveFile}
                                                setSaveFile={setSaveFile}
                                                setCurrentFile={setCurrentFile}
                                                setIsModalEditFile={setIsModalEditFile}
                                                files={true}
                                                currentPermission={role}
                                                disabled={!can_manage}
                                            />
                                        </label>
                                    );
                                })
                                :
                                <span className='files-page__no-file'>Здесь пока нет ни одного файла</span>
                            }
                        </>
                        :
                        <TableBox
                            {...tableProps}
                            ref={paginatorRef}
                            loading={load}
                            fetchCallback={currentFetchGetList}
                            contextMenuArr={contextMenuArr}
                        />

                    )}
                    {Paginator}

                    {/* Визуальная область выделения */}
                    {selectionRect && isSelecting && (
                        <div
                            className="files-page__selection-rect"
                            style={{
                                left: selectionRect.left,
                                top: selectionRect.top,
                                width: selectionRect.width,
                                height: selectionRect.height,
                            }}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export { FilesPage };